import type { DriverDayOffSourceType, DriverDayOffStatus, DriverDayOffType } from '@/backend/market'

export class DriverDayOffEntity {
  id?: string
  driverId?: number
  driverFullName?: string | null
  driverAvatarImagePath?: string | null
  driverRegionId?: number
  requestedByUserId?: string | null
  approvedByUserId?: string | null
  rejectedByUserId?: string | null
  startDate?: string
  endDate?: string
  type?: DriverDayOffType
  reason?: string | null
  status?: DriverDayOffStatus
  source?: DriverDayOffSourceType
  reviewNotes?: string | null
  attachmentImagePath?: string | null
  canceledAt?: string | null
  completedAt?: string | null
  createdAt?: string
  updatedAt?: string
}
